import { FormFieldConfig, FormFieldType } from "../../interface";
import { BedBoardSettingsStatus } from "./bedboard-settings.interface";

export const UPLOAD_CONFIG = {
  acceptedTypes: ["csv"],
  maxSizeMb: 2,
  showSelection: false, // not used here, allows us to use ready-made validation function
  allowRemoveExistingFile: false, // not used here
};

const SELECT_VALUES = Object.values(BedBoardSettingsStatus).map(id => ({ id, label: id }));

export const SELECT_CONFIG: FormFieldConfig = {
  label: "",
  key: "",
  type: FormFieldType.Select,
  options: [
    { id: '', label: '' },
    ...SELECT_VALUES,
  ],
};

export const CSV_DELIMITER = ",";

export const ERRORS = {
  IMPORT: "An error occurred. Was unable to import the CSV file.",
  GET: "Could not get current settings. Please try again later.",
  UPDATE: "An error occurred. Could not update the report's settings.",
};

export const COLUMN_CONFIGS = [
  {
    label: "Action Code ID",
    key: "action_code_id",
  },
  {
    label: "Status Code ID",
    key: "status_code_id",
  },
  {
    label: "Action Long Desc.",
    key: "action_long_desc",
  },
  {
    label: "Action Fac. ID",
    key: "action_fac_id",
  },
  {
    label: "Action Type",
    key: "action_action_type",
  },
  {
    label: "Status Long Desc.",
    key: "status_long_desc",
  },
  {
    label: "Status Action Type",
    key: "status_action_type",
  },
  {
    label: "Status Short Desc.",
    key: "status_short_desc",
  },
  {
    label: "Action Short Desc.",
    key: "action_short_desc",
  },
  {
    label: "Usage Count",
    key: "usage_count",
  },
];